export default class EventOptions {
    static modelName = 'EventOptions';
    id: number
    activ: boolean = true
    description: string
    [key: string]: any
}